<template>
  <!-- 1. 监听 search 和 export 事件 -->
  <tb-header
      :form-data="formInline"
      @search="onSubmit"
      @export="handleExport"
  />

  <!-- 2. 传递 tableData 数据和处理方法给内容组件 -->
  <tb-content
      :tableData="sharedTableData"
      :handleEdit="handleEdit"
      :handleDelete="handleDelete"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      @page-change="handlePageChange"
  ></tb-content>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import TbHeader from '@/components/h_tb_header/tb_header.vue';
import TbContent from '@/components/h_tb_content/tb_content.vue';
import {useTable} from "@/components/h_tb_content/tb_content_data";
import {FormInline} from "@/components/h_tb_header/tb_header_data";
import {useCheckPage} from "./h_check_page_data";
import {ElLoading} from "element-plus";

// 定义数据类型
interface Tb {
  "idCardNo": string,
  "phone": string,
  "price": string,
  "transAmt": string,
  "rePayTime": string | null,
  "payTime": string,
  "state": string,
  "type": string,
  "reqSeqId": string,
  "reqDate": string,
  "isD": boolean | null,
  'gong': string ,
  "multiPeriodNo": string,
}

// 表单数据（由父组件定义，传给子组件）
const formInline = ref<FormInline>({
  idCard: '',
  cardMp: '',
  cardNo: '',
  state: '',
  date: ["", ""],
  reqSeqId: '',
  hfSeqId: '',
  reqDate: '',
});


// 1. 定义共享数据状态
const sharedTableData = ref<Tb[]>([])

// 2. 使用页面逻辑（支持外部传入状态实现动态变化）
const {currentPage, pageSize, total, onSubmit, handlePageChange, handleExport} = useCheckPage(
    sharedTableData,
    formInline,
    {
      // 可选：传入外部响应式状态实现动态变化
      // currentPage: ref(1),
      // pageSize: ref(10),
      // total: ref(0)
    },
    () => {
      // onSubmit();
    }
)

// 3. 初始化表格逻辑，传入共享数据引用
const {handleEdit, handleDelete} = useTable(sharedTableData, () => {
  const loadingInstance = ElLoading.service({fullscreen: true})
  setTimeout(() => {
    loadingInstance.close();
    onSubmit()
  }, 3000); // 1000毫秒 = 1秒
});

// 初始加载
// onSubmit();
</script>

<style scoped>
/* 页面级样式 */
</style>
